import { extend } from 'ol/extent.js'
import { GEObject } from './GEObject.js'
import { nanoid } from 'nanoid';
export class Shape extends GEObject {
	
	selected = false
	highlighted = false
	parent = null
	deferUpdates = false
	children = []
	id = nanoid()
	properties = {}
	constructor() {
		super()
	}
	unfocus() {
		this.deferUpdates = true
		this.setSelected(false, true, true)
		this.setHighlighted(false, true, true)
		this.deferUpdates = false
		this.trigger('changed', this, {
			selected: false,
			highlighted: false
		})
	}
	setProperty(key, value) {
		if(value === this.properties[key]) {
			return
		}
		this.properties[key] = value
		this.trigger('changed', this, {key: value})
	}
	setHighlighted(highlighted, updateParent = true, updateChildren = true) {
		this.highlighted = highlighted
		if(updateParent && this.parent) {
			this.parent.setHighlighted(highlighted, updateParent, updateChildren)
		}
		if(updateChildren) {
			for(let child of this.children) {
				child.setHighlighted(highlighted, false, false)
			}
		}
		this.trigger('changed', this, {highlighted})
	}
	setSelected(selected, updateParent = true, updateChildren = true) {
		this.selected = selected
		if(updateParent && this.parent) {
			this.parent.setSelected(selected, updateParent, updateChildren)
		}
		if(updateChildren) {
			for(let child of this.children) {
				child.setSelected(selected, false, false)
			}
		}
		this.trigger('changed', this, {selected})
	}
	tidyRotation() {
		throw new Error('tidyRotation not implemented')
	}
	getType() {
		throw new Error('getType not implemented')
	}
}